import { Location } from './contact-us.type';

export const locations: Location[] = [
  {
    id: 1,
    name: 'Clovis Classics',
    category: 'landmark',
    address: '516 5th Street #202, Clovis, CA 93612',
    position: [36.8250, -119.7029], // Clovis, CA coordinates
    description: '516 5th Street #202, Clovis, CA 93612',
    icon: 'map-pin',
  }
];

export const categories = [
  { id: 'all', name: 'All Locations', icon: 'map' },
  { id: 'restaurant', name: 'Restaurants', icon: 'utensils' },
  { id: 'cafe', name: 'Cafés', icon: 'coffee' },
  { id: 'shopping', name: 'Shopping', icon: 'shopping-bag' },
  { id: 'hotel', name: 'Hotels', icon: 'hotel' },
  { id: 'service', name: 'Services', icon: 'landmark' },
  { id: 'entertainment', name: 'Entertainment', icon: 'sparkles' },
  { id: 'outdoors', name: 'Outdoors', icon: 'umbrella-beach' },
  { id: 'landmark', name: 'Landmarks', icon: 'map-pin' },
];
